import axios from 'axios';
import { CLIENT } from "./constants";
import { getSession, clearSession, SESSION_EXPIRED_EVENT } from "./authSession";

const apiClient = axios.create({ baseURL: CLIENT.baseUrl });

apiClient.interceptors.request.use((config) => {
    const session = getSession();
    if (session) {
        config.headers.Authorization = `Bearer ${session.token}`;
    }
    return config;
});

// A 401 on any request other than login means the token expired or was rejected,
// so drop the session and let AuthProvider log the user out.
apiClient.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            clearSession();
            window.dispatchEvent(new Event(SESSION_EXPIRED_EVENT));
        }
        return Promise.reject(error);
    }
);

const postDecoration = (formBody) => apiClient.post(`v1/decoration/post`, formBody)

const fetchBookingList = () => apiClient.get('v1/booking/list');

export {
    postDecoration,
    fetchBookingList,
}